import { render } from "./email.vue?vue&type=template&id=24eed793"
import script from "./email.vue?vue&type=script&lang=js"
export * from "./email.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bob/Documents/GitHub/codfather/email nationalGrid/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__